<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Pedido</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div v-if="isDataLoaded" class="col-lg-6 col-5 text-right">
          <router-link
            v-if="$can('store', 'orders')"
            :to="{ name: 'OrderEdit', params: { id: order.id } }"
            class="btn base-button btn-neutral btn-sm"
          >
            Editar
          </router-link>
        </div>
      </div>
    </base-header>
    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div class="col-sm-12">
          <order-detail :order="order" :order-id="orderId" @download-pdf="getPdf" />

          <order-payments-detail v-if="showPayments" :dollar-quote="dollarQuote" :items="order.items" :order="order" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import OrderDetail from './Show/OrderDetail';
import OrderPaymentsDetail from './Show/OrderPaymentsDetail';
import OrderEventBus from '@/events/buses/orders.event';
import OrderStatesMixin from '@/mixins/orderStatesMixin';
import { getDollarQuote } from '@/util/orders';

export default {
  name: 'OrdersShow',
  components: {
    RouteBreadCrumb,
    OrderDetail,
    OrderPaymentsDetail,
  },

  mixins: [OrderStatesMixin],
  data() {
    return {
      isDataLoaded: false,
      orderId: null,
      order: null,
    };
  },

  computed: {
    showPayments() {
      return this.isOrderPending || this.isOrderAccepted;
    },

    dollarQuote() {
      return getDollarQuote(this.order);
    },
  },

  mounted() {
    this.orderId = +this.$route.params.id;
    this.fetchOrder();
  },

  created() {
    OrderEventBus.$on('orders-new-state', this.setNewState);
  },

  beforeDestroy() {
    OrderEventBus.$off('orders-new-state', this.setNewState);
  },

  methods: {
    fetchOrder() {
      const params = {
        include: [
          'producer.distributor.seller',
          'campaign',
          'state',
          'items.article',
          'user',
          'projection',
          'dollarQuotation',
        ],
      };

      this.$services
        .resource('orders')
        .show(this.orderId, params)
        .then((res) => res.data.data)
        .then((order) => {
          this.order = order;
          this.isDataLoaded = true;
        });
    },

    getPdf() {
      let filename = `Pedido-#${this.order.code}.pdf`;
      this.$services.resource('orders').getPdf(this.order.id, filename);
    },
  },
};
</script>
